import * as actionTypes from './actionTypes';
import * as actions from './index';

const deleteCommentStart = () => {
    return {
        type: actionTypes.DELETE_COMMENT_START
    };
};

const deleteCommentSuccess = () => {
    return {
        type: actionTypes.DELETE_COMMENT_SUCCESS
    };
};

const deleteCommentFail = (error) => {
    return {
        type: actionTypes.DELETE_COMMENT_FAIL,
        error: error
    };
};

export const deleteComment = (id, clipId, projectId) => {
    return dispatch => {
        dispatch(deleteCommentStart());
        window.flow.delComments(id).then(res => {
            dispatch(deleteCommentSuccess());
            dispatch(getComments(clipId, projectId));
        }).catch(res => {
            dispatch(deleteCommentFail(res.message));
            dispatch(actions.applicationError(res.message));
        });
    };
};

const getCommentsStart = () => {
    return {
        type: actionTypes.GET_COMMENTS_START
    };
};

const getCommentsSuccess = (res, clipId, projectId) => {
    return {
        type: actionTypes.GET_COMMENTS_SUCCESS,
        payload: { comments: res, clipId: clipId, projectId: projectId }
    };
};

const getCommentsFail = (error) => {
    return {
        type: actionTypes.GET_COMMENTS_FAIL,
        error: error
    };
};

export const getComments = (clipId, projectId = 0) => {
    return dispatch => {
        dispatch(getCommentsStart());
        window.flow.getComments({clipid:clipId, project:projectId, type:'comment'}).then(res => {
            dispatch(getCommentsSuccess(res, clipId, projectId));
        }).catch(res => {
            dispatch(getCommentsFail(res.message));
            dispatch(actions.applicationError(res.message));
        });
    };
};

const addCommentStart = () => {
    return {
        type: actionTypes.ADD_COMMENT_START
    };
};

const addCommentSuccess = () => {
    return {
        type: actionTypes.ADD_COMMENT_SUCCESS
    };
};

const addCommentFail = (error) => {
    return {
        type: actionTypes.ADD_COMMENT_FAIL,
        error: error
    };
};

export const addComment = (comment, clipId, projectId, name) => {
    return dispatch => {
        dispatch(addCommentStart());
        window.flow.editComment({clipid:clipId, project:projectId, type:'comment', comment:comment, name:name}).then(res => {
            dispatch(addCommentSuccess());
            dispatch(getComments(clipId, projectId));
        }).catch(res => {
            dispatch(addCommentFail(res.message));
            dispatch(actions.applicationError(res.message));
        });
    };
};
